import React, { useState } from 'react';
import { updateTransaction } from '../services/transactionService';
import { completeTransactionTask, generateBirthdayTasks } from '../services/transactionTasks';

// TC quick action: enter each client's birthday on the deal. Saves the dates and creates the agent's yearly
// "Wish ... Happy Birthday" tasks, then completes this task.
const isBirthdayTask = (name) => /^Add Client Birthdays$/i.test(name || '');

const peopleFor = (deal) => {
  const list = [];
  const first = [deal?.firstName, deal?.lastName].filter(Boolean).join(' ');
  if (first) list.push({ key: 'primary', name: first });
  (deal?.additionalContacts || []).forEach((c, i) => {
    const name = [c?.firstName, c?.lastName].filter(Boolean).join(' ');
    if (name) list.push({ key: `contact-${i}`, name });
  });
  return list;
};

export default function ClientBirthdayQuickEntry({ task, deal, ownerUid, transactionId, onSent }) {
  const [open, setOpen] = useState(false);
  const [dates, setDates] = useState({});
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  if (!isBirthdayTask(task?.name || task?.title)) return null;

  const people = peopleFor(deal);
  const btn = { display: 'inline-block', padding: '8px 14px', borderRadius: 6, fontWeight: 700, fontSize: 13, border: '1px solid #B8962E', background: '#B8962E', color: '#FFFFFF', cursor: 'pointer', marginRight: 8 };

  const save = async () => {
    const entered = people.filter(p => dates[p.key]).map(p => ({ name: p.name, date: dates[p.key] }));
    if (entered.length === 0) { setMessage('Enter at least one birthday.'); return; }
    setSaving(true);
    setMessage('');
    try {
      const uid = ownerUid;
      await updateTransaction(uid, transactionId, { clientBirthdays: entered });
      const result = await generateBirthdayTasks(transactionId, entered, uid);
      await completeTransactionTask(transactionId, task.id, 'TC');
      setMessage(`Saved. ${result.created} birthday wish tasks added for the agent.`);
      if (onSent) onSent();
    } catch (err) {
      console.error('Could not save birthdays', err);
      setMessage('Could not save the birthdays.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ marginTop: 8, padding: 10, border: '1px solid #E5E0D3', borderRadius: 6, background: '#FFFFFF' }}>
      <button type="button" onClick={() => setOpen(o => !o)} style={btn}>{open ? 'Hide birthdays' : 'Enter client birthdays'}</button>
      {open && (
        <div style={{ marginTop: 10 }}>
          {people.length === 0 && <div style={{ fontSize: 12, color: '#5B6270' }}>No clients saved on this deal.</div>}
          {people.map(p => (
            <div key={p.key} style={{ marginBottom: 8 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>{p.name} birthday</label>
              <input type="date" value={dates[p.key] || ''} onChange={(e) => setDates({ ...dates, [p.key]: e.target.value })} style={{ padding: 8, fontSize: 13 }} />
            </div>
          ))}
          <button type="button" onClick={save} disabled={saving || people.length === 0} style={btn}>{saving ? 'Saving...' : 'Save birthdays'}</button>
          {message && <div style={{ fontSize: 12, color: '#5B6270', marginTop: 6 }}>{message}</div>}
        </div>
      )}
    </div>
  );
}
